import { gql, TypedDocumentNode } from 'apollo-angular';

export class Queries {

  public static readonly GetNewsCategories = gql`query NewsCategories {
    newsCategories {
      id
      name {
        nl
        en
      }
    }
  }`;
  
  public static GetPaginatedCompanyNews(all: boolean): TypedDocumentNode {
    if (all) {
      return gql `query CompanyNews($first: Int, $after: String) {
        companyNews(
          first: $first,
          after: $after,
          order: {
            date: DESC
          }
        ) {
          nodes {
            id
            categoryId
            category {
              id
              name {
                nl
                en
              }
            }
            date
            title
            excerpt
            content
            contentDelta
            thumbnailFileName
            thumbnailUrl
          }
          pageInfo {
            hasNextPage
            endCursor
          }
        }
      }
    `;
    } else {
      return gql `query CompanyNews($categoryIds: [String!], $first: Int, $after: String) {
        companyNews(
          first: $first,
          after: $after,
          where: {
            categoryId: {
              in: $categoryIds
            }
          }
          order: {
            date: DESC
          }
        ) {
          nodes {
            id
            categoryId
            category {
              id
              name {
                nl
                en
              }
            }
            date
            title
            excerpt
            content
            contentDelta
            thumbnailFileName
            thumbnailUrl
          }
          pageInfo {
            hasNextPage
            endCursor
          }
        }
      }
    `;
    }
  }
}
